export default "__VITE_ASSET__Cex06ms8__"